const styles = ({ FONT_SIZES, BREAKPOINTS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    [`@media (max-width: ${BREAKPOINTS.MD}) and (orientation: portrait)`]: {
      flexDirection: 'column'
    }
  },
  cat: {
    display: 'block',
    height: '100%',
    flex: '0',
    [`@media (max-width: ${BREAKPOINTS.MD}) and (orientation: portrait)`]: {
      width: '100vw',
      height: '100vw'
    }
  },
  textBox: {
    fontSize: '16px',
    backgroundColor: '#fff',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    [`@media (max-width: 320px) and (orientation: portrait)`]: {
      fontSize: '14px'
    }
  },
  title: {
    fontSize: '1.85em',
    lineHeight: '1.06',
    fontWeight: 'bold',
    margin: '0 0 0.66em'
  },
  desc: {
    fontSize: '1em',
    lineHeight: '1.25',
    margin: '0'
  }
})

export default styles
